import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import RemitterAccountDetails from "../../../../containers/Accounts/RemitterAccount/RemitterAccountDetails";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const RemitAccountDetailsPopup = ({
  rem_account_id,
  popup,
  headerTitle,
  headersubtext,
  closeRemAccountDetailModal,
  flow,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle={headerTitle}
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          headersubtext={headersubtext}
          smallPopupHeader="Confirm leaving this page?"
          smallpopupsubtext="Leaving this page will exit from the current flow."
          isfullViewrequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewhandleFunction={() => {
            closeRemAccountDetailModal();
            navigate(
              `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${rem_account_id}`,
            );
          }}
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          fullviewdisabledBgColor="var(--text-disabled)"
          closeiconbtnType="button"
          closeiconhandleFunction={closeRemAccountDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <RemitterAccountDetails
            rem_account_id={rem_account_id}
            closeRemAccountDetailModal={closeRemAccountDetailModal}
            popup={popup}
            flow={flow}
          />
        </LargePopupRedirect>
      </div>
    </>
  );
};

export default RemitAccountDetailsPopup;
